import { render, staticRenderFns } from "./stockComponent.vue?vue&type=template&id=64d733e9&scoped=true"
import script from "./stockComponent.vue?vue&type=script&lang=js"
export * from "./stockComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d733e9",
  null
  
)

export default component.exports